$(function(){
    $('.b-line-diagram').each(function(){
        var $context = $(this),
            $items = $('.b-line-diagram__item', $context),
            numbers = [],
            maxItem = 0;

        for(let i = 0; i < $items.length; i++){
            let number = parseInt($('.b-line-diagram__number', $items.eq(i)).text());
            numbers.push(number);
        }

        maxItem = Math.max.apply(Math, numbers);

        $items.each(function(){
            let $item = $(this),
                $diagram = $('.b-line-diagram__diagram', $item),
                number = parseInt($('.b-line-diagram__number', $item).text()),
                diagramWidth = (100 * number) / maxItem;

            $diagram.width(diagramWidth+'%');
        })

    });
})